import Choices from "choices.js";
import Swiper from "swiper";
import {Controller, Navigation, EffectFade, Autoplay} from 'swiper/modules';

export default class Global {

    constructor() {
        this.handleForm();
        // this.initChoices();
        this.verhaalSlider();
        this.initReviews();
        setTimeout(() => {
            this.transitionAfterPageLoad();
        }, 300);
    }

    transitionAfterPageLoad(){
        document.querySelector("body").classList.remove("no-transition");
    }

    initChoices() {
        const elements = document.querySelectorAll('.js-choice');
        let choices;

        elements.forEach(element => {
            choices = new Choices(element);
        });
    }

    verhaalSlider() {
        if(document.querySelector("#verhaalSlider")){

            const imageSwiper = new Swiper('#verhaalImagesSlider .swiper-container', {
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                modules: [Controller, EffectFade],
                effect: 'fade',
                loop: true
            });

            imageSwiper.controller.control = new Swiper('#verhaalSlider .swiper-container', {
                modules: [Navigation, Controller, EffectFade, Autoplay],
                navigation: {
                    nextEl: "#verhaalSlider .swiper-button-next",
                    prevEl: "#verhaalSlider .swiper-button-prev",
                },
                controller: {
                    control: imageSwiper,
                },
                slidesPerView: 1,
                effect: 'fade',
                loop: true,
                autoplay: {
                    delay: 5500,
                },
            });
        }
    }

    handleForm() {
        if (document.querySelector('.form-style')) {
            const formGroups = document.querySelectorAll('.form-style .form-group-custom:not(.select)');

            formGroups.forEach((item) => {
                const input = item.querySelector('input, textarea');

                const handleFocus = () => {
                    item.classList.add('focus');
                }

                const handleBlur = () => {
                    if (input.value.length === 0) {
                        item.classList.remove('focus');
                    }
                }

                const handleInput = () => {
                    if (input.value.length === 0 && document.activeElement === input) {
                        item.classList.add('focus');
                    } else if (input.value.length > 0) {
                        item.classList.add('focus');
                    } else {
                        item.classList.remove('focus');
                    }
                }

                input.addEventListener('focus', handleFocus);
                input.addEventListener('blur', handleBlur);
                input.addEventListener('input', handleInput);

                if (input.value.length > 0) {
                    item.classList.add('focus');
                }
            });
        }
    }

    initReviews() {
        if(document.querySelectorAll('#reviewSlider') !== null){
            new Swiper('#reviewSlider .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 30,
                loop:true,
                autoplay: {
                    delay: 3500,
                },
                breakpoints: {
                    576: {
                        slidesPerView: 2,
                    },
                    1200: {
                        slidesPerView: 2,
                    }
                }
            });
        }
    }
}
